import DepiLogin from '../components/depi/Login';
import DepvLogin from '../components/depv/Login';
import EnplusLogin from '../components/enplus/Login';

const getLoginFormComponent = context => {
  switch (context) {
    case 'pellets':
    case 'hackschnitzel':
    case 'holzbriketts':
      return EnplusLogin;
    case 'depi':
      return DepiLogin;
    case 'depv':
      return DepvLogin;
    default:
      return DepiLogin;
  }
};

export default getLoginFormComponent;
